import { render, staticRenderFns } from "./LibrisSearch.vue?vue&type=template&id=471fe9fc"
import script from "./LibrisSearch.vue?vue&type=script&lang=js"
export * from "./LibrisSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports